module.exports = __webpack_public_path__ + "static/media/week-3b.f951d13c.jpeg";